import React from 'react';
import clsx from 'clsx';

import { MentionTypeaheadOption } from './mention-typeahead-option';

import styles from './formula-editor.scss';

const MENU_ITEM_BASE_INDENT_PX = 10;
const MENU_ITEM_DEPTH_INDENT_PX = 8;

interface MentionMenuItemProps {
  index: number;
  isSelected: boolean;
  nonSelectableOptionIds: string[];
  onClick: () => void;
  onMouseEnter: () => void;
  option: MentionTypeaheadOption;
}

export const MentionMenuItem = ({
  index,
  isSelected,
  nonSelectableOptionIds,
  onClick,
  onMouseEnter,
  option
}: MentionMenuItemProps) => {
  const { depth = 1, disabled, id, name } = option.mention;
  // Sub-group headers (e.g. the "Sales"/"Expenses"/... row-formula groups, depth 1) are rendered bold
  // just like top-level category headers (depth 0), matching the draft-js editor's behaviour.
  const isGroupHeader = depth === 1 && nonSelectableOptionIds.includes(String(id));
  const isNonSelectable = disabled || depth === 0 || nonSelectableOptionIds.includes(String(id));

  return (
    <div
      ref={option.setRefElement.bind(option)}
      role="option"
      aria-selected={isSelected}
      aria-disabled={isNonSelectable}
      id={`typeahead-item-${index}`}
      onMouseDown={event => event.preventDefault()}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      className={clsx(styles.mentionMenuItem, { [styles.noClick]: isNonSelectable })}
      style={
        depth === 0
          ? { fontWeight: 500 }
          : {
            padding: `7px 10px 3px ${MENU_ITEM_BASE_INDENT_PX + depth * MENU_ITEM_DEPTH_INDENT_PX}px`,
            ...(isGroupHeader ? { fontWeight: 500 } : {})
          }
      }
    >
      <div
        className={styles.mentionMenuItemText}
        style={disabled ? { color: 'rgb(129, 139, 159)', textDecoration: 'line-through' } : undefined}
      >
        {name}
      </div>
    </div>
  );
};
